import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnavailabilityFormComponent } from './unavailability-form.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/index";



@NgModule({
  declarations: [UnavailabilityFormComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    PipesModule
  ],
  exports:[UnavailabilityFormComponent]
})
export class UnavailabilityFormModule { }
